import { makeStyles } from 'tss-react/mui';
import { Paper, PaperProps, Theme } from '@mui/material';
import React from 'react';

export interface PanelProps extends PaperProps {
    children?: React.ReactNode;
}

const useStyles = makeStyles()((theme: Theme) =>
    ({
        panel: {
            margin: theme.spacing(1),
            position: 'relative',
        }
    }));

const initialProps: PanelProps = {};

const Panel: React.FC<PanelProps> = (props) => {
    const [state, setState] = React.useState<PanelProps>({ ...initialProps, ...props });
    const { children, ...paperProps } = props;
    const { classes, cx } = useStyles();

    React.useEffect(() => {
        setState((prevState) => ({ ...prevState, ...props }));
    }, [props]);

    return (
        <Paper {...paperProps} className={cx(classes.panel, state.className)}>
            {state.children}
        </Paper>
    );
};

export default Panel;
